import { SET_NOTIFICATION, MARK_AS_READ, CLEAR_NOTIFICATIONS } from "./action";

// Ensure initial state has notifications as an array
const initialState = {
  notifications: [] // This must be an array
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      // Ensure we're always working with arrays
      return {
        ...state,
        notifications: Array.isArray(state.notifications) 
          ? [...state.notifications, action.payload]
          : [action.payload] // If notifications wasn't an array, create a new array
      };
      
    case MARK_AS_READ:
      return {
        ...state,
        notifications: Array.isArray(state.notifications) 
          ? state.notifications.map(notification =>
              notification.id === action.payload 
                ? { ...notification, read: true }
                : notification
            )
          : [] // If not an array, return empty array
      };
      
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [] // Always return empty array
      };
      
    default:
      return state;
  }
};

export default notificationReducer;